import './index.scss';

import { Application } from 'utils/stimulus';

import LessonCardController from 'helpers/lessons/lesson_card/index';

if (!global.LessonCardApplication) {
  global.LessonCardApplication = Application.start();
  global.LessonCardApplication.register('lesson-card', LessonCardController);
}
